<template>
    <div>
        <van-tabbar v-model="active" active-color="#14B9B5" inactive-color="#000">
            <van-tabbar-item v-for="item in menuList" :to="item.url" :icon="item.icon">{{item.name}}</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        props: ['menuList', 'active'],
        data() {
            return {
            }
        },
        methods:{
        }
    }

</script>

<style>

</style>